import { useCallback, useState } from 'react';
import {
    CustomerSupportButtonText,
    CustomerSupportDescription,
    CustomerSupportHeadline
} from 'autogen/translation-keys/trans-website-chat';
import { AcceptMarketingCookiesToSeeElementBody, ChatNotAllowed } from 'autogen/translation-keys/trans-website-shared';
import CookieInfobox from 'components/CookieInfobox/CookieInfobox';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import useHasInformationCookieBeenAccepted from 'hooks/user/useHasInformationCookieBeenAccepted';
import { t } from 'i18next';
import { CookieCategory } from 'modules/helpers/cookieInformationHelper';
import { CHAT_ENTRY_DRAWER_ID } from '../ChatEntry';
import ChatAgentOption from '../components/ChatAgentOption';
import initZowie from './zowie';

const ChatAgentOptionZowie = () => {
    const { close: closeMainChat } = useDrawer(CHAT_ENTRY_DRAWER_ID, { disableOverlay: true });
    const isMarketingCookieAccepted = useHasInformationCookieBeenAccepted(CookieCategory.marketing);
    const [showMissingConsentOverlay, setShowMissingConsentOverlay] = useState(false);
    const [hasInitializedZowie, setHasInitializedZowie] = useState(false);

    const open = useCallback(async () => {
        if (hasInitializedZowie) {
            window.Zowie.open();
            return;
        }

        if (!isMarketingCookieAccepted) {
            setShowMissingConsentOverlay(true);
            return;
        }

        // TODO: Figure out if Zowie has been initialized already
        // TODO: Add state that shows that it has startet initializing but is not done yet. ATM you can click open before it is done
        setHasInitializedZowie(true);
        await new Promise<void>((resolve) => {
            initZowie({
                onLoaded: () => {
                    window.Zowie.open();
                },
                onShow: () => {
                    closeMainChat();
                    resolve();
                }
            });
        });
    }, [isMarketingCookieAccepted, hasInitializedZowie, closeMainChat]);

    return (
        <>
            <ChatAgentOption
                title={t(CustomerSupportHeadline)}
                description={t(CustomerSupportDescription)}
                buttonText={t(CustomerSupportButtonText)}
                icon="Advice"
                open={open}
            />
            {!isMarketingCookieAccepted && showMissingConsentOverlay && (
                <CookieInfobox
                    callback={() => setShowMissingConsentOverlay(false)}
                    headline={t(ChatNotAllowed)}
                    body={t(AcceptMarketingCookiesToSeeElementBody)}
                />
            )}
        </>
    );
};

export default ChatAgentOptionZowie;
